export const GET_UPLOAD_MODEL_SIMULATION_FILE_FORMAT_MOCK =  {
  fileFormat: 'csv'
}